'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AddEstimate = function AddEstimate(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M6,18v-3H4v3H1v2h3v3h2v-3h3v-2H6z"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: "M19.001,2.939h-4.179c-0.42-1.087-1.519-1.875-2.819-1.875c-1.299,0-2.399,0.787-2.819,1.875H5.004c-1.1,0-2,0.844-2,1.875\n\t\tV13h2V4.813h2v2.812h9.997V4.813h2v14.997H11v1.875h8.001c1.099,0,1.999-0.844,1.999-1.875V4.813C21,3.783,20.1,2.939,19.001,2.939\n\t\tz M12.003,4.813c-0.549,0-1-0.422-1-0.937c0-0.516,0.451-0.938,1-0.938c0.551,0,0.999,0.422,0.999,0.938\n\t\tC13.002,4.392,12.554,4.813,12.003,4.813z"
  })));
};

var AddEstimate$1 = iconStyles()(AddEstimate);

module.exports = AddEstimate$1;
